class Settings {
    static #chatMaxInputLength = 100;

    static get chatMaxInputLength() {
        return this.#chatMaxInputLength;
    }
}

export default Settings;